import { render, staticRenderFns } from "./CartSubclipList.vue?vue&type=template&id=28cb6b92"
import script from "./CartSubclipList.vue?vue&type=script&lang=js"
export * from "./CartSubclipList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports